import {
  Redirect,
  Route,
  Switch,
  useLocation,
  BrowserRouter,
} from "react-router-dom";
import { GlobalStyle } from "./GlobalStyle";

import { Main } from "../common/Main";
import { Footer } from "../common/Footer";
import { Top } from "../common/Top/Top";
import { Renowacja } from "../features/renowacja-felg/renowacja";
import { SocialSection, SocialsIcons } from "../common/Socials/SocialSection";
import { Tiles } from "../common/Top/Tiles";
import { Malowanie } from "../features/malowanie-proszkowe/malowanie";
import { Wynajem } from "../features/wynajem/wynajem";
import GoToTopButton from "../common/GoUp/GoUp";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { NotFound } from "../features/wynajem/bio";
import { MessengerLink } from "../common/messenger";
import { TopBar } from "../common/TopBar/topbar";
import { Canonical } from "../common/Canonical";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
 

function App() {
  return (
    <HelmetProvider>
      <GlobalStyle />
      <BrowserRouter basename="/">
        <ScrollToTop />
        <MessengerLink />
        <SocialsIcons />
        <Canonical/>
        <TopBar/>
        <Top />
        <Main>
          <Switch>
            <Route path="/renowacja-felg">
              <Renowacja backToMain={true} />
            </Route>
            <Route path="/malowanie-proszkowe">
              <Malowanie />
            </Route>
            <Route path="/wynajem">
              <Wynajem />
            </Route>
            <Route path="/strona-glowna">
              <Tiles />
            </Route>
            <Route exact path="/">
              <Redirect to="/strona-glowna" />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Main>

        <SocialSection />
        <Footer />
        <GoToTopButton showAt={250} size={56} shape="rounded" />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
